var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcKeySecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.65733 9.50666C8.084 8.58666 7.85467 7.55466 7.85467 6.40666C7.84719 5.65091 7.9905 4.90125 8.27623 4.20155C8.56196 3.50185 8.98436 2.86615 9.51873 2.33167C10.0531 1.79718 10.6887 1.37463 11.3883 1.08874C12.088 0.802845 12.8376 0.659355 13.5933 0.66666C14.3492 0.659176 15.099 0.802535 15.7988 1.08835C16.4985 1.37416 17.1343 1.79668 17.6688 2.33119C18.2033 2.86569 18.6258 3.50144 18.9116 4.20123C19.1975 4.90102 19.3408 5.65079 19.3333 6.40666C19.3406 7.16242 19.1971 7.91204 18.9113 8.61168C18.6254 9.31131 18.2028 9.9469 17.6683 10.4813C17.1338 11.0156 16.4981 11.438 15.7984 11.7238C15.0987 12.0095 14.3491 12.1528 13.5933 12.1453C12.3307 12.1453 11.2987 11.8013 10.2653 11.112L7.62533 13.752L8.888 15.016L7.28 16.6227L6.01733 15.36L5.21467 16.164L6.47733 17.4267L4.86933 19.0333L2 16.164L8.65733 9.50533V9.50666ZM13.5933 2.96266C11.6427 2.96266 10.1507 4.45599 10.1507 6.40666C10.1507 8.35733 11.6427 9.84933 13.5933 9.84933C15.5453 9.84933 17.0373 8.35733 17.0373 6.40666C17.0373 4.45466 15.4307 2.96266 13.5933 2.96266Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcKeySecurity);
export default __webpack_public_path__ + "static/media/ic_key_security.742ba78e8f3c8321019e52e523ea18bc.svg";
export { ForwardRef as ReactComponent };